export default __webpack_public_path__ + "static/media/kitchen-slim.383d49a5.png";